import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=78c0556e&scoped=true&"
import script from "./BankCard.vue?vue&type=script&lang=js&"
export * from "./BankCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0556e",
  null
  
)

export default component.exports